import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import './ProfilePopover.css';

import isElectron from '../utils/is-electron.js';

import UserAvatar from './UserAvatar.js';
import AvailabilityIndicator from './AvailabilityIndicator.js';
import PopoverList from './PopoverList.js';
import PopoverListItem from './PopoverListItem.js';
import PopoverListToggle from './PopoverListToggle.js'
import PopoverListDropdown from './PopoverListDropdown.js';
import PopoverListDropdownItem from './PopoverListDropdownItem.js';

class ProfilePopover extends Component {
  constructor(props) {
    super(props);

    this.state = {
      doNotDisturb: false,
      availability: 1
    };
  }

  signOut = () => {
    console.log('Signing out...');
    if (confirm('Are you sure you want to log out? This will sign you out of any running Normal Chat sessions.')) {
      browserHistory.push('/logout');
    }
  }

  openSettings = () => {
    browserHistory.push('/app/account');
    this.props.close();
  }

  toggleDND = () => {
    console.log('Toggling dnd!');
    this.setState({ doNotDisturb: !this.state.doNotDisturb });
  }

  changeAvailability = (availability) => {
    console.log("Got new availability value!", availability);
    this.setState({ availability });
    this.props.onUpdateAvailability(Number(availability));
  }

  render() {
    const { visible, user } = this.props;
    let classNames = ['ProfilePopover', 'TetheredPopover'];
    if (visible) {
      classNames.push('TetheredPopover--visible');
    }

    let currentAvailabilityIndicator = <AvailabilityIndicator availability={user.availability} />;

    let electronSettings;
    if (isElectron()) {
      electronSettings = (
        <PopoverList>
          <PopoverListDropdown value={user.availability} onChange={this.changeAvailability} label="Status" valueLabelPrefix={currentAvailabilityIndicator}>
            <PopoverListDropdownItem value={1} label="Available">Available</PopoverListDropdownItem>
            <PopoverListDropdownItem value={2} label="Away">Away</PopoverListDropdownItem>
            <PopoverListDropdownItem value={3} label="Busy">Busy</PopoverListDropdownItem>
            <PopoverListDropdownItem value={0} label="Invisible">Invisible</PopoverListDropdownItem>
          </PopoverListDropdown>

          <PopoverListToggle
            label="Do Not Disturb"
            checked={this.state.doNotDisturb}
            onToggle={this.toggleDND} />
        </PopoverList>
      );
    }

    return (
      <div className={classNames.join(' ')}>
        <section className="ProfilePopoverUser">
          <UserAvatar user={user} wrapperClassName="ProfilePopoverUser__avatar-wrap" />
          <section className="ProfilePopoverUser__info">
            <h3 className="ProfilePopoverUser__name">{user.name}</h3>
            <span className="NormalToken">1234-1234-1234-1234</span>
          </section>
        </section>

        {electronSettings}

        <PopoverList>
          <PopoverListItem onClick={this.openSettings}>Settings</PopoverListItem>
          <PopoverListItem onClick={this.signOut} destroyStyle={true}>Sign out</PopoverListItem>
        </PopoverList>
      </div>
    );
  }
};

export default ProfilePopover;



// WEBPACK FOOTER //
// ./src/components/ProfilePopover.js